/**
 * Dynamic Thumbnail Spacing
 * Adds data attributes based on thumbnail count for CSS targeting
 */
document.addEventListener("DOMContentLoaded", function() {
  // Only run on mobile
  if (window.innerWidth > 767) return;
  
  function setThumbnailSpacing() {
    // Get the product grid and thumbnails
    const productGrid = document.querySelector('.product-page-grid');
    const thumbnails = document.querySelectorAll('.thumbnail-item');
    
    if (!productGrid || !thumbnails.length) {
      console.warn('Product grid or thumbnails not found');
      return;
    }
    
    // Count the thumbnails
    const thumbnailCount = thumbnails.length;
    
    // Add data attribute to the product grid for CSS targeting
    productGrid.setAttribute('data-thumbnails', thumbnailCount);
    
    console.log(`Set thumbnail count to ${thumbnailCount} for dynamic spacing`);
  }
  
  // Set spacing initially
  setThumbnailSpacing();
  
  // Set again after a short delay to catch any dynamic loading
  setTimeout(setThumbnailSpacing, 500);
  
  // Handle window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth <= 767) {
      setThumbnailSpacing();
    }
  });
  
  // Handle orientation change
  window.addEventListener('orientationchange', function() {
    setTimeout(function() {
      if (window.innerWidth <= 767) {
        setThumbnailSpacing();
      }
    }, 300);
  });
  
  // Watch for changes to thumbnails (variant changes)
  try {
    const mediaContainer = document.querySelector('.product-media-container');
    if (mediaContainer) {
      const observer = new MutationObserver(function() {
        setTimeout(function() {
          if (window.innerWidth <= 767) {
            setThumbnailSpacing();
          }
        }, 100);
      });
      
      observer.observe(mediaContainer, { 
        subtree: true, 
        childList: true 
      });
    }
  } catch (e) {
    console.error("Error setting up thumbnail observer:", e);
  }
});
